import {hostName} from "../../../endpoint";
import {defaultHeaders} from "../../../headers";

export const deleteRole = async (id) => {
  try {
    const result = await fetch(`${hostName}/business/team-role/${id}`, {
      method: "DELETE",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (error) {
    return {
      hasSuccess: false,
      data: error.message,
    };
  }
};
